import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
import type { PillarPageContent } from '../types/pillarPage';
type DisciplineSectionProps = {
  content: PillarPageContent['discipline'];
};
export function DisciplineSection({
  content
}: DisciplineSectionProps) {
  return <section className="relative w-full overflow-hidden bg-ink" data-id="element-18" data-mp="2fah9pia8ttda">
      <img src={content.image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25" data-id="element-19" data-mp="2k929xhphwd1q" />
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,#080909,rgba(8,9,9,0.86),#080909)]" aria-hidden="true" data-id="element-20" data-mp="2t0koxpapgmt8" />

      <div className="relative mx-auto w-full max-w-[1240px] px-6 py-28 sm:px-10 lg:py-40" data-id="element-21" data-mp="2xych8kf9iaxy">
        <Reveal data-id="element-22" data-mp="32ztfe86d3jau">
          <Eyebrow data-id="element-23" data-mp="330bnc22dzlyl">{content.eyebrow}</Eyebrow>
          <h2 className="mt-6 max-w-2xl text-3xl font-extrabold leading-[1.08] tracking-[-0.025em] text-bone sm:text-4xl lg:text-[3.3rem]" data-id="element-24" data-mp="37xlilycgiruc">
            {content.titleTop}
            <span className="block text-accent" data-id="element-25" data-mp="1tcwa97vilidu">{content.titleAccent}</span>
          </h2>
        </Reveal>

        <div className="mt-10 max-w-lg space-y-5 text-[15px] leading-relaxed text-ash sm:text-base" data-id="element-26" data-mp="1oi8upyihnybe">
          {content.paragraphs.map((paragraph, i) => <Reveal key={paragraph} delay={0.05 + i * 0.03} data-id="element-27" data-mp="1fgj2wrkp2xd3" data-mpi={i}>
              <p data-id="element-28" data-mp="2c576iivnyi2z">{paragraph}</p>
            </Reveal>)}
          <Reveal delay={0.11} data-id="element-29" data-mp="2c7l0spiirq9h">
            <p className="text-bone" data-id="element-30" data-mp="276nlqlst3cc7">{content.closingParagraph}</p>
          </Reveal>
        </div>

        <ol className="mt-20 flex flex-col gap-4 lg:flex-row lg:items-stretch" data-id="element-31" data-mp="22ffbxonkdoyi">
          {content.sequence.map((step, i) => <React.Fragment key={step} data-id="element-32" data-mp="1yd0th5nt4r7r" data-mpi={i}>
              <Reveal as="li" delay={0.12 * i} className="lg:flex-1" data-id="element-33" data-mp="1ybzfasbhvolt">
                <div className="flex h-full items-center gap-5 rounded-2xl border border-accent-deep/70 bg-surface/80 px-7 py-6 backdrop-blur-sm" data-id="element-34" data-mp="2uwrkofv1unwv">
                  <span className="text-[11px] font-bold text-accent/60" data-id="element-35" data-mp="o7pq63eveine">{`0${i + 1}`}</span>
                  <span className="text-sm font-bold uppercase tracking-label text-bone" data-id="element-36" data-mp="t6ssvh7docs7">
                    {step}
                  </span>
                </div>
              </Reveal>
              {i < content.sequence.length - 1 && <Reveal as="li" delay={0.12 * i + 0.06} className="flex items-center justify-center lg:w-8" data-id="element-37" data-mp="jfxuxfkrroqx">
                  <ArrowRightIcon className="h-4 w-4 rotate-90 text-accent/50 lg:rotate-0" aria-hidden="true" data-id="element-38" data-mp="agububllr9cf" />
                </Reveal>}
            </React.Fragment>)}
        </ol>

        <Reveal delay={0.1} data-id="element-39" data-mp="k7sjr8xcqci">
          <p className="mt-16 max-w-2xl text-xl font-bold leading-snug tracking-[-0.01em] text-bone sm:text-2xl" data-id="element-40" data-mp="1pxbas3z44rd7">
            {content.closingLead} <span className="text-accent" data-id="element-41" data-mp="1uuuzjxtfsmje">{content.closingAccent}</span>
          </p>
        </Reveal>
      </div>
    </section>;
}